import httpClient from './httpClient';

export const CONTENT_BLOCK_ENDPOINT = '/backoffice/content-blocks';

export const getContentBlocksAPI = (params = {}) => httpClient.get(CONTENT_BLOCK_ENDPOINT, { params });
export const getContentBlockAPI = (id, type) => httpClient.get(`${CONTENT_BLOCK_ENDPOINT}/${type}/${id}`);
export const createContentBlockAPI = (params) => httpClient.post(CONTENT_BLOCK_ENDPOINT, params);
export const updateContentBlockAPI = (id, params) => httpClient.put(`${CONTENT_BLOCK_ENDPOINT}/${id}`, params);
export const deleteContentBlockAPI = (id) => httpClient.delete(`${CONTENT_BLOCK_ENDPOINT}/${id}`);
